export default function ItemCounter({
  show,
  max,
  value,
  incrementFunction,
  decrementFunction,
  customOnChange,
  onBlur,
}) {
  const onChange = (event) => {
    customOnChange(event);
  };

  return (
    <div hidden={!show}>
      <form className="max-w-xs mx-auto mt-1">
        <div className="relative flex items-center max-w-[11rem]">
          <button
            onClick={decrementFunction}
            type="button"
            id="decrement-button"
            className="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-s-lg px-2 h-6 focus:ring-gray-100 focus:ring-2 focus:outline-none"
          >
            <svg
              className="w-3 h-3 text-gray-900 "
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 2"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M1 1h16"
              />
            </svg>
          </button>
          <input
            type="text"
            id="number input"
            data-input-counter
            data-input-counter-min={0}
            data-input-counter-max={max || 10}
            className="bg-gray-50 border-x-0 border-gray-300 h-6 font-medium text-center text-gray-900 text-sm focus:ring-blue-500 focus:border-blue-500 w-[6.5ch] appearance-none [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
            placeholder=""
            onChange={onChange}
            onBlur={onBlur}
            value={value}
          />

          <button
            onClick={incrementFunction}
            type="button"
            id="increment-button"
            className="bg-gray-100 hover:bg-gray-200 border border-gray-300 rounded-e-lg px-2 h-6 focus:ring-gray-100 focus:ring-2 focus:outline-none"
          >
            <svg
              className="w-3 h-3 text-gray-900 "
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 18 18"
            >
              <path
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M9 1v16M1 9h16"
              />
            </svg>
          </button>
        </div>
      </form>
    </div>
  );
}
